import {c as createCommonjsModule} from "./_commonjsHelpers-8c19dec8.js";
import {c as esm} from "./defaultTheme-ca6a0b43.js";
var useEnhancedEffect = createCommonjsModule(function(module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  var _default = esm.unstable_useEnhancedEffect;
  exports.default = _default;
});
export {useEnhancedEffect as u};
